document.addEventListener('click', function (e) {
  const link = e.target.closest('.custom_load_more a');
  if (!link) return;

  e.preventDefault();

  const scrollURL = link.getAttribute('href');

  fetch(scrollURL)
    .then(response => response.text())
    .then(data => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');

      const newMore = doc.querySelector('.custom_load_more');
      const currentMore = document.querySelector('.custom_load_more');

      // 🔹 Load more button handle
      if (newMore && newMore.innerHTML.trim() !== '') {
        currentMore.innerHTML = newMore.innerHTML;
      } else {
        if (currentMore) currentMore.style.display = 'none'; // hide button
      }

      // 🔹 Append products
      const newProducts = doc.querySelector('#product-grid');
      const productGrid = document.querySelector('#product-grid');

      if (newProducts && productGrid) {
        productGrid.insertAdjacentHTML('beforeend', newProducts.innerHTML);
      }
    })
    .catch(err => console.error('Load more error:', err));
});
